import {
  TreemapModule,
  createTreemapServices
} from "./chunk-OZEHJAEY.mjs";
import "./chunk-XZSTWKYB.mjs";
export {
  TreemapModule,
  createTreemapServices
};
